// import Vue from 'vue'
// import  from 'vue-router'

import { marxy } from './initMarxy'

import trackPageVisit from './events/pageVisit'
import trackViewItem from './events/viewItem'
import trackSessionPing from './events/sessionPing'
import trackCartUpdate from './events/cartUpdate'
import trackViewCategory from './events/viewCategory'

marxy.eventTracking = {
  trackCartUpdate,
  // other events
}

export const marxyEvents = {
  TRACK_CART_UPDATE: trackCartUpdate,
  TRACK_PAGE_VISIT: trackPageVisit,
  TRACK_SESSION_PING: trackSessionPing,
  TRACK_VIEW_CATEGORY: trackViewCategory,
  TRACK_VIEW_ITEM: trackViewItem,
}
